import Translator from '../../classes/Translator/Translator';

const InteractiveMapLogic = () => {
  const { translator } = Translator();

  return {
    translator,
  };
};

export default InteractiveMapLogic;
